import classnames from 'classnames'
import { ReactNode } from 'react'

import { REVEAL_TIME_MS } from '../../constants/settings'
import { CharStatus } from '../../lib/statuses'
import { solution } from '../../lib/words'

type Props = {
  children?: ReactNode
  value: string
  status?: CharStatus
  onClick: (value: string) => void
  isRevealing?: boolean
}

export const Key = ({
  children,
  status,
  value,
  onClick,
  isRevealing,
}: Props) => {
  const keyDelayMs = REVEAL_TIME_MS * solution.length

  let conditional_rules = {
    'transition ease-in-out': isRevealing,
    grow: ['ENTER', 'DELETE'].includes(value),
  }
  if (status) {
    // @ts-ignore
    conditional_rules[status] = ['absent', 'present', 'correct'].includes(
      status
    )
  }

  const classes = classnames(
    'key flex-1 xxshort:h-8 xxshort:text-xxs xshort:h-10 flex short:h-12 h-14 items-center justify-center rounded text-xs font-bold cursor-pointer select-none dark:text-white',
    conditional_rules
  )

  const styles = {
    transitionDelay: isRevealing ? `${keyDelayMs}ms` : 'unset',
  }

  const handleClick: React.MouseEventHandler<HTMLButtonElement> = (event) => {
    onClick(value)
    event.currentTarget.blur()
  }

  return (
    <button
      style={styles}
      aria-label={`${value}${status ? ' ' + status : ''}`}
      className={classes}
      onClick={handleClick}
    >
      {children || value}
    </button>
  )
}
